// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { QueryKeys } from "../queryKeys";
import { key } from "localforage";

export enum SettingsGroupCode {
  MERCHANTTYPE = "MERCHANTTYPE",
  INSTALLMENTCOUNT = "INSTALLMENTCOUNT",
  MENUTYPE = "MENUTYPE",
  RESOURCETYPE = "RESOURCETYPE",
  TRNXSUBTYPE = "TRNXSUBTYPE",
  PAYMENT3DTXNTYPE = "PAYMENT3DTXNTYPE",
  TRNXSTATUS = "TRNXSTATUS",
  PAYMENTMODEL = "PAYMENTMODEL",
  LINKSTATUS = "LINKSTATUS",
  MICROSERVICE = "MICROSERVICE",
  PASSWORD = "PASSWORD",
  MERCHANT_LIMIT = "MERCHANT_LIMIT",
  MerchantCurrentBalanceType = "MerchantCurrentBalanceType",
  TRANSACTION_PAYMENT_MODEL = "TRANSACTION_PAYMENT_MODEL",
}

export type GetSettingsListRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  groupCode?: SettingsGroupCode;
  status?: string;
};

async function getSettingsList(data: GetSettingsListRequest): Promise<any> {
  try {
    if (data?.page && data?.size || data?.key === "REQUIREDMAXLENGTH")
      return (await axiosInstance.post("/Setting/List", data)).data;
    else
      return (await axiosInstance.post("/Setting/ListWithoutPagination", data))
        .data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}



export function useGetMerchantTypeSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.MERCHANTTYPE,
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetSettingsMerchantType, data],
    () => getSettingsList(data)
  );
}

export function useGetInstallmentCountSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.INSTALLMENTCOUNT,
    status,
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetSettingsInstallmentCount, data],
    () => getSettingsList(data)
  );
}

export function useGetMenuTypeSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.MENUTYPE,
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetMenuTypeList, data],
    () => getSettingsList(data)
  );
}

export function useGetResourceTypeSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.RESOURCETYPE,
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetResourceType, data],
    () => getSettingsList(data)
  );
}

export function useGetTransactionSubTypeSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE"
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.TRNXSUBTYPE,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetTransactionSubTypeList, data],
    () => getSettingsList(data)
  );
}

export function useGetPayment3DTrxSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.PAYMENT3DTXNTYPE,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetPayment3DTrxList, data],
    () => getSettingsList(data)
  );
}

export function useGetTrxStatusSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE"
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.TRNXSTATUS,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetTransactionStatusList, data],
    () => getSettingsList(data)
  );
}

export function useGetPaymentModelSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.PAYMENTMODEL,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetPaymentModelList, data],
    () => getSettingsList(data)
  );
}

export function useGetLinkedPaymentStatusList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.LINKSTATUS,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetLinkedPaymentStatusList, data],
    () => getSettingsList(data)
  );
}

export function useGetMicroserviceStatusList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.MICROSERVICE,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetMicroserviceStatusList, data],
    () => getSettingsList(data)
  );
}


export function useGetPasswordMaxLengthSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.PASSWORD,
    key: "REQUIREDMAXLENGTH",
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetSettingsPasswordMaxLength, data],
    () => getSettingsList(data)
  );
}

export function useGetMerchantLimitSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.MERCHANT_LIMIT,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetSettingsMerchantLimit, data],
    () => getSettingsList(data)
  );
}
export function useGetMerchantCurrentBalanceTypeSettingsList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.MerchantCurrentBalanceType,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.MerchantCurrentBalanceType, data],
    () => getSettingsList(data)
  );
}

export function useGetTransactionPaymentModel({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE",
}: GetSettingsListRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    groupCode: SettingsGroupCode.TRANSACTION_PAYMENT_MODEL,
    status
  };

  return useQuery<any | undefined, Error>(
    [QueryKeys.GetPayment3DTrxList, data],
    () => getSettingsList(data)
  );
}